import React from 'react'

import { MintField as Field } from '@/domain/liquidity'
import type { OnChainPairData } from '@/features/market/useOnChainPairData'
import type { AddLiquidityControllerResult } from '@/features/liquidity/useAddLiquidityController'
import type { CandleInterval } from '@nutrimatic/sdk'

import { MobileAddLiquidityRateHero } from '../mobile/MobileAddLiquidityQuoteBlocks'
import { LiquidityNutrimaticTabletMarketPane } from './LiquidityNutrimaticTabletMarketPane'

/** Pantalla de mercado en tableta para añadir liquidez. */
export function LiquidityNutrimaticTabletChartPane({
  controller,
  pairData,
  chartTimeframe,
  onChartTimeframeChange,
}: {
  controller: AddLiquidityControllerResult
  pairData: OnChainPairData
  chartTimeframe: CandleInterval
  onChartTimeframeChange: (interval: CandleInterval) => void
}) {
  return (
    <LiquidityNutrimaticTabletMarketPane
      currencyA={controller.currencies[Field.CURRENCY_A]}
      currencyB={controller.currencies[Field.CURRENCY_B]}
      pairData={pairData}
      rateHero={<MobileAddLiquidityRateHero controller={controller} />}
      chartTimeframe={chartTimeframe}
      onChartTimeframeChange={onChartTimeframeChange}
    />
  )
}
